<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('contactsPage.manageContacts') }} </h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card>
                        <el-tabs>
                            <el-tab-pane :label="$t('contactsPage.billingContacts')">
                                <el-tabs
                                    v-model="selectedHotelIdBillingContactsTab"
                                    tab-position="left"
                                    :class="{'hide-tab-pane': hotels.length === 1}">
                                    <el-tab-pane :label="$t('contactsPage.hotelGroup')" name="-1">
                                        <el-button
                                            type="primary"
                                            class="mb-3"
                                            @click="openContactEditor({
                                            client_id: hotelGroup.id,
                                            client_type: 'hotel_group',
                                            contact_type: 'billing',
                                            })">{{ $t('contactsPage.addNewContact') }}
                                        </el-button>

                                        <el-table
                                            class="table-responsive table-flush"
                                            header-row-class-name="thead-light"
                                            :data="hotelGroup.billing_contacts"
                                            :empty-text="isLoadingData
                                            ? $t('general.loading') + '...'
                                            : $t('contactsPage.noBillingContactAddedToHotelGroup')">
                                            <el-table-column :label="$t('general.name')" prop="name" sortable></el-table-column>
                                            <el-table-column :label="$t('general.email')" prop="email" sortable></el-table-column>
                                            <el-table-column :label="$t('general.phone')" prop="phone" sortable></el-table-column>
                                            <el-table-column
                                                :label="$t('general.actions')"
                                                width="130px"
                                                class-name="actions-column"
                                                v-slot="{row: contact}">
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.editContact')"
                                                    placement="top">
                                                    <button type="button" @click="openContactEditor(contact)">
                                                        <i class="ai ai-edit text-yellow"></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.deleteContact')"
                                                    placement="top">
                                                    <button type="button" @click="deleteContactAttention(contact)">
                                                        <i class="ai ai-remove text-danger"></i>
                                                    </button>
                                                </el-tooltip>
                                            </el-table-column>

                                        </el-table>
                                    </el-tab-pane>
                                    <el-tab-pane
                                        v-for="hotel in hotels"
                                        :key="hotel.id"
                                        :label="hotel.name"
                                        :name="hotel.id.toString()">
                                        <el-button
                                            type="primary"
                                            class="mb-3"
                                            @click="openContactEditor({
                                            client_id: hotel.id,
                                            client_type: 'hotel',
                                            contact_type: 'billing',
                                            })">{{ $t('contactsPage.addNewContact') }}
                                        </el-button>

                                        <el-table
                                            class="table-responsive table-flush"
                                            header-row-class-name="thead-light"
                                            :data="hotel.billing_contacts"
                                            :empty-text="isLoadingData
                                            ? $t('general.loading') + '...'
                                            : $t('contactsPage.noBillingContactAddedToHotel')">
                                            <el-table-column :label="$t('general.name')" prop="name" sortable></el-table-column>
                                            <el-table-column :label="$t('general.email')" prop="email" sortable></el-table-column>
                                            <el-table-column :label="$t('general.phone')" prop="phone" sortable></el-table-column>
                                            <el-table-column
                                                :label="$t('general.actions')"
                                                width="130px"
                                                class-name="actions-column"
                                                v-slot="{row: contact}">
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.editContact')"
                                                    placement="top">
                                                    <button type="button" @click="openContactEditor(contact)">
                                                        <i class="ai ai-edit text-yellow"></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.deleteContact')"
                                                    placement="top">
                                                    <button type="button" @click="deleteContactAttention(contact)">
                                                        <i class="ai ai-remove text-danger"></i>
                                                    </button>
                                                </el-tooltip>
                                            </el-table-column>

                                        </el-table>
                                    </el-tab-pane>
                                </el-tabs>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('contactsPage.generalContacts')">
                                <el-tabs
                                    v-model="selectedHotelIdGeneralContactsTab"
                                    tab-position="left"
                                    :class="{'hide-tab-pane': hotels.length === 1}">
                                    <el-tab-pane :label="$t('contactsPage.hotelGroup')" name="-1">
                                        <el-button
                                            type="primary"
                                            class="mb-3"
                                            @click="openContactEditor({
                                            client_id: hotelGroup.id,
                                            client_type: 'hotel_group',
                                            contact_type: 'general',
                                            })">{{ $t('contactsPage.addNewContact') }}
                                        </el-button>

                                        <el-table
                                            class="table-responsive table-flush"
                                            header-row-class-name="thead-light"
                                            :data="hotelGroup.general_contacts"
                                            :empty-text="isLoadingData
                                            ? $t('general.loading') + '...'
                                            : $t('contactsPage.noGeneralContactAddedToHotelGroup')">
                                            <el-table-column :label="$t('general.name')" prop="name" sortable></el-table-column>
                                            <el-table-column :label="$t('general.email')" prop="email" sortable></el-table-column>
                                            <el-table-column :label="$t('general.phone')" prop="phone" sortable></el-table-column>
                                            <el-table-column
                                                :label="$t('general.actions')"
                                                width="130px"
                                                class-name="actions-column"
                                                v-slot="{row: contact}">
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.editContact')"
                                                    placement="top">
                                                    <button type="button" @click="openContactEditor(contact)">
                                                        <i class="ai ai-edit text-yellow"></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.deleteContact')"
                                                    placement="top">
                                                    <button type="button" @click="deleteContactAttention(contact)">
                                                        <i class="ai ai-remove text-danger"></i>
                                                    </button>
                                                </el-tooltip>
                                            </el-table-column>

                                        </el-table>
                                    </el-tab-pane>
                                    <el-tab-pane
                                        v-for="hotel in hotels"
                                        :key="hotel.id"
                                        :label="hotel.name"
                                        :name="hotel.id.toString()">
                                        <el-button
                                            type="primary"
                                            class="mb-3"
                                            @click="openContactEditor({
                                            client_id: hotel.id,
                                            client_type: 'hotel',
                                            contact_type: 'general',
                                            })">{{ $t('contactsPage.addNewContact') }}
                                        </el-button>

                                        <el-table
                                            class="table-responsive table-flush"
                                            header-row-class-name="thead-light"
                                            :data="hotel.general_contacts"
                                            :empty-text="isLoadingData
                                            ? $t('general.loading') + '...'
                                            : $t('contactsPage.noGeneralContactAddedToHotel')">
                                            <el-table-column :label="$t('general.name')" prop="name" sortable></el-table-column>
                                            <el-table-column :label="$t('general.email')" prop="email" sortable></el-table-column>
                                            <el-table-column :label="$t('general.phone')" prop="phone" sortable></el-table-column>
                                            <el-table-column
                                                :label="$t('general.actions')"
                                                width="130px"
                                                class-name="actions-column"
                                                v-slot="{row: contact}">
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.editContact')"
                                                    placement="top">
                                                    <button type="button" @click="openContactEditor(contact)">
                                                        <i class="ai ai-edit text-yellow"></i>
                                                    </button>
                                                </el-tooltip>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="$t('contactsPage.deleteContact')"
                                                    placement="top">
                                                    <button type="button" @click="deleteContactAttention(contact)">
                                                        <i class="ai ai-remove text-danger"></i>
                                                    </button>
                                                </el-tooltip>
                                            </el-table-column>

                                        </el-table>
                                    </el-tab-pane>
                                </el-tabs>
                            </el-tab-pane>
                        </el-tabs>
                    </card>
                </div>
            </div>
        </div>
        <el-dialog
            :title="$t('general.warning')"
            :visible.sync="showDeleteContactAttentionModal"
            width="550px"
            center>
            <div class="h2 text-center">
                {{ $t('contactsPage.warningQuestion') }}:
                <br>
                {{ selectedContactForDelete.name }}?
            </div>
            <div slot="footer" class="dialog-footer">
                <base-button
                    outline
                    type="secondary"
                    @click="showDeleteContactAttentionModal = false">{{ $t('general.cancel') }}
                </base-button>
                <base-button type="danger" @click="deleteContact">{{ $t('general.delete') }}</base-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="selectedContact.id ? $t('contactsPage.editContact') : $t('contactsPage.addNewContact')"
            :visible.sync="showContactEditorModal"
            width="550px"
            center
            @closed="closeContactEditor">
            <el-form>
                <el-form-item :label="$t('contactsPage.user')">
                    <el-select
                        v-model="selectedContact.user_id"
                        placeholder=" "
                        style="width:100%;"
                        @change="contactUserChanged">
                        <el-option :label="`-- ${$t('contactsPage.noUserSelected')} --`" :value="undefined"></el-option>
                        <el-option
                            v-for="user in users"
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"></el-option>
                    </el-select>
                </el-form-item>

                <hr>

                <el-form-item :label="$t('general.name')">
                    <el-input
                        v-model="selectedContact.name"
                        :disabled="!!selectedContact.user_id"></el-input>
                </el-form-item>

                <el-form-item :label="$t('general.email')">
                    <el-input
                        v-model="selectedContact.email"
                        :disabled="!!selectedContact.user_id"></el-input>
                </el-form-item>

                <el-form-item :label="$t('general.phone')">
                    <el-input v-model="selectedContact.phone"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <base-button outline type="danger" @click="closeContactEditor">{{ $t('general.cancel') }}</base-button>
                <base-button
                    type="success"
                    :disabled="!contactCanBeSave"
                    @click="saveContact">
                    <i class="ai ai-save"></i>
                    {{ selectedContact.id ? $t('general.save') : $t('general.add') }}
                </base-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import {BaseProgress} from '@/components';
    import {
        Button,
        Dialog,
        Form,
        FormItem,
        Option,
        Select,
        Table,
        TableColumn,
        TabPane,
        Tabs,
        Tooltip,
    } from 'element-ui'

    export default {
        name: 'user-list',
        components: {
            BaseProgress,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Tooltip.name]: Tooltip,
        },
        computed: {
            contactCanBeSave: {
                get() {
                    const contact = this.selectedContact;
                    return contact.name && contact.email && contact.phone;
                }
            },
        },
        data() {
            return {
                hotelGroup: {},
                hotels: [],
                applications: [],
                users: [],
                currentPage: 1,
                itemsPerPage: 10,
                itemsCount: 0,
                isLoadingData: true,
                showContactEditorModal: false,
                selectedContact: {},
                showDeleteContactAttentionModal: false,
                selectedContactForDelete: {},
                selectedHotelIdBillingContactsTab: '-1',
                selectedHotelIdGeneralContactsTab: '-1',
            }
        },
        methods: {
            openContactEditor(contact) {
                this.showContactEditorModal = true;
                this.selectedContact = JSON.parse(JSON.stringify(contact));
            },
            closeContactEditor() {
                this.showContactEditorModal = false;
            },
            saveContact() {
                if (this.selectedContact.id) {
                    this.$axios.put('/api/contacts/' + this.selectedContact.id, this.selectedContact)
                        .then(res => {
                            const contact = res.data.data;

                            if (contact.client_type === 'hotel_group') {
                                const contactIdx = this.hotelGroup[contact.contact_type + '_contacts']
                                    .findIndex(c => c.id === contact.id);
                                this.hotelGroup[contact.contact_type + '_contacts'][contactIdx] = contact;
                                this.hotelGroup[contact.contact_type + '_contacts'] = [...this.hotelGroup[contact.contact_type + '_contacts']]
                            } else if (contact.client_type === 'hotel') {
                                const hotel = this.hotels.find(hotel => hotel.id === contact.client_id);
                                const contactIdx = hotel[contact.contact_type + '_contacts']
                                    .findIndex(c => c.id === contact.id);
                                hotel[contact.contact_type + '_contacts'][contactIdx] = contact;
                                hotel[contact.contact_type + '_contacts'] = [...hotel[contact.contact_type + '_contacts']];
                            }

                            this.closeContactEditor();

                            this.$notify({
                                title: this.$t('contactsPage.contactUpdated'),
                            });
                        })
                        .catch(({response}) => {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$notify({
                                    title: errors[key][0],
                                    type: 'danger',
                                });
                            }
                        });
                } else {
                    this.$axios.post('/api/contacts', this.selectedContact)
                        .then(res => {
                            const contact = res.data.data;

                            if (contact.client_type === 'hotel_group') {
                                this.hotelGroup[contact.contact_type + '_contacts'].push(contact);
                                this.hotelGroup[contact.contact_type + '_contacts'] = [...this.hotelGroup[contact.contact_type + '_contacts']];
                            } else if (contact.client_type === 'hotel') {
                                const hotel = this.hotels.find(hotel => hotel.id === contact.client_id);
                                hotel[contact.contact_type + '_contacts'].push(contact);
                                hotel[contact.contact_type + '_contacts'] = [...hotel[contact.contact_type + '_contacts']];
                            }

                            this.closeContactEditor();

                            this.$notify({
                                title: this.$t('contactsPage.contactAdded'),
                            });
                        })
                        .catch(({response}) => {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$notify({
                                    title: errors[key][0],
                                    type: 'danger',
                                });
                            }
                        });
                }
            },
            deleteContactAttention(contact) {
                this.selectedContactForDelete = contact;
                this.showDeleteContactAttentionModal = true;
            },
            deleteContact() {
                this.$axios.delete('/api/contacts/' + this.selectedContactForDelete.id)
                    .then(res => {
                        const contact = this.selectedContactForDelete;

                        if (contact.client_type === 'hotel_group') {
                            this.hotelGroup[contact.contact_type + '_contacts'] = this.hotelGroup[contact.contact_type + '_contacts']
                                .filter(c => c.id !== contact.id);
                        } else if (contact.client_type === 'hotel') {
                            const hotel = this.hotels.find(hotel => hotel.id === contact.client_id);
                            hotel[contact.contact_type + '_contacts'] = hotel[contact.contact_type + '_contacts']
                                .filter(c => c.id !== contact.id);
                        }

                        this.$notify({
                            title: this.$t('contactsPage.contactDeleted'),
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            title: err.response.data,
                            type: 'danger',
                        });
                    })
                    .then(() => {
                        this.selectedContactForDelete = {};
                        this.showDeleteContactAttentionModal = false;
                    })
            },
            contactUserChanged(userId) {
                let selectedUser = {};

                if (userId) {
                    selectedUser = this.users.find(user => user.id === userId);
                }

                this.selectedContact = {
                    ...this.selectedContact,
                    name: selectedUser.name || null,
                    email: selectedUser.email || null,
                    phone: selectedUser.phone || null,
                };

            }
        },
        async created() {
            this.isLoadingData = true;
            this.hotelGroup = (await this.$axios.get('/api/hotel-group')).data.data;
            this.hotels = (await this.$axios.get('/api/hotels?include=subscriptions,billingContacts,generalContacts')).data.data;
            this.applications = (await this.$axios.get('/api/applications')).data.data;
            this.users = (await this.$axios.get('/api/users')).data.data;
            this.isLoadingData = false;
        }
    }
</script>
<style lang="scss">
    .filter-container {
        display: inline-flex;
        margin-right: .5rem;
    }

    .permission-editor-modal {
        .el-dialog__body {
            padding: 0;
        }
    }

    .permission-pagination {
        display: table;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1rem;
    }

    .flex-right {
        display: flex;
        justify-content: flex-end;
    }
</style>
